import * as React from "react"

// Returns a keyboard handler that fires `submit` when the user presses
// Cmd/Ctrl + Enter. Attach via `onKeyDownCapture` on the form (or any
// wrapper element) so the combo fires before rich-text editors like
// Milkdown swallow the Enter for their own keymap.
export function useCmdEnterSubmit<E extends HTMLElement = HTMLElement>(
  submit: () => void,
): React.KeyboardEventHandler<E> {
  return React.useCallback(
    (e: React.KeyboardEvent<E>) => {
      if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        e.stopPropagation()
        submit()
      }
    },
    [submit],
  )
}
